import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "error",
  "use": "error-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"error\"><defs><style></style></defs><path d=\"M807.588 986.223L512.534 691.298l-295.63 295.437a126.698 126.698 0 01-179.425 0 126.57 126.57 0 010-179.297L333.11 512 37.415 216.562a126.57 126.57 0 010-179.297 126.698 126.698 0 01179.362 0L512.47 332.702 807.46 37.777A126.698 126.698 0 11987.014 217.01L691.96 512.064 986.95 806.99a126.57 126.57 0 010 179.233 126.954 126.954 0 01-179.298 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol